export const ENDPOINTS = {
  city: "/master/area",
  type: "/english-course/schedule-by-area",
  program: "/english-course/program-by-detail",
  classMeets: "/english-course/type-by-detail",
  listTeacher: "/english-course/list-teacher",
  bizdev: "/ambassador/consultant/jobdesk",
  payment: "/english-course/detail-payment",
  member: "/members/check-member/",
  checkout: "/checkout-english/",
  free: "/checkout-english-trial",
  normal: "/checkout-english",
  recap: "/recap-home-statis",
  eventElicos: "event/jenis-event-date/7",
};
